import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42cd0dc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "product_wrap" }
const _hoisted_2 = {
  key: 0,
  class: "product_title"
}
const _hoisted_3 = { class: "product_info_inner_wrap" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "product_info_con" }
const _hoisted_6 = { class: "product_info_meta" }
const _hoisted_7 = { class: "selection_label line_break" }
const _hoisted_8 = { class: "selection_product" }
const _hoisted_9 = { class: "product_info_price" }
const _hoisted_10 = { class: "price_label" }
const _hoisted_11 = { class: "price_price" }

import { MachineInfo } from '@/models/landingPage';
    import { PropType } from 'vue';
    import Row from '../common/RowSection.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsInfo',
  props: {
        machine: { type: Object as PropType<MachineInfo>, required: true },
    },
  setup(__props) {

const props = __props

    const GENERAL_MACHINE_IMAGES =
        'https://static.nayax.com/res/media/201710301322385926/machine_general.png';

    

    const HandleProductPic = function (productPic: string) {
        if (productPic) return productPic;
        else if (props.machine.machineTypeLutImage) {
            return props.machine.machineTypeLutImage;
        }

        return GENERAL_MACHINE_IMAGES;
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.machine)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('Your Product')), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.machine.products, (product) => {
      return (_openBlock(), _createBlock(Row, {
        key: product.selectionId
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["product_pic_con box_shadow", [product.image ? 'product_pic_con' : 'machine_type_image_con']])
            }, [
              _createElementVNode("img", {
                src: HandleProductPic(product.image)
              }, null, 8, _hoisted_4)
            ], 2),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.$t('Selection ID')) + ": " + _toDisplayString(product.selectionId), 1),
                _createElementVNode("h5", _hoisted_8, _toDisplayString(product.name), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h5", _hoisted_10, _toDisplayString(_ctx.$t('Price')), 1),
                _createElementVNode("h3", _hoisted_11, _toDisplayString(__props.machine?.currencySign) + _toDisplayString(product.price ?? 0.0), 1)
              ])
            ])
          ])
        ]),
        _: 2
      }, 1024))
    }), 128))
  ]))
}
}

})